export default "__VITE_ASSET__DzK15NMD__"